/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getConsentDecision} from '../api'

 export const useQueryGetConsentDecision = createReactQueryHook('getConsentDecision', getConsentDecision)
